import { FulfillmentStatus } from "../../utils/constants";
import {
	createOrder,
	deleteOrderCookies, getOrderConfirmationData,
	getOrderData, getOrderDataById
} from "../../api/orderController";

export const createOrderData = async ({
	salesPersonCode,
	logisticsMethod,
	billingAddressId,
	shippingAddressId,
	collectionAddressId,
	items,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError,
	setErrorMessage
}) => {
	setStatusInProgress();
	try {
		let response = await createOrder(
			{
				salesPersonCode: salesPersonCode ?? "155",
				logisticsMethod: logisticsMethod,
				orderItems: items.map((item) => ({
					sku: item.sku,
					quantity: item.quantity,
					fulfillmentStatusId: FulfillmentStatus.New
				})),
				billingAddressId: billingAddressId,
				shippingAddressId: shippingAddressId,
				collectionAddressId: collectionAddressId
			}
		);

		if (!!response?.success) {
			setStatusSuccess();
		}
		else {
			if (!!setErrorMessage) {
				setErrorMessage(response?.message || "Could not place your order. Please refresh the page and try again.");
			}
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const fetchOrderData = async ({
	setOrderData,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		let response = await getOrderData();
		if (!!response?.success) {
			setOrderData(response?.data);
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const fetchOrderDataById = async ({
	orderId,
	setOrderData,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		let response = await getOrderDataById(orderId);
		if (!!response?.success) {
			setOrderData(response?.data);
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const fetchOrderConfirmationData = async ({
	orderId,
	setOrderData,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		let response = await getOrderConfirmationData(orderId);
		if (!!response?.success) {
			setOrderData(response?.data);
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const removeOrderCookies = async ({
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		let response = await deleteOrderCookies();
		if (!!response?.success) {
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};
